import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-view",
  "use": "icon-view-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" id=\"icon-view\"><defs><style type=\"text/css\"></style></defs><path d=\"M512 832c-204.8 0-387.2-121.6-470.4-307.2-3.2-9.6-3.2-16 0-25.6C124.8 313.6 307.2 192 512 192s387.2 121.6 470.4 307.2c3.2 9.6 3.2 16 0 25.6C899.2 710.4 716.8 832 512 832zM108.8 512c73.6 156.8 230.4 256 403.2 256s329.6-99.2 403.2-256c-73.6-156.8-230.4-256-403.2-256S182.4 355.2 108.8 512zM512 672c-89.6 0-160-70.4-160-160s70.4-160 160-160 160 70.4 160 160-70.4 160-160 160z m0-256c-54.4 0-96 41.6-96 96s41.6 96 96 96 96-41.6 96-96-41.6-96-96-96z\" p-id=\"6089\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/view.svg
// module id = zjNx
// module chunks = 20